var verbs = [
  {
    id: 0,
    text: 'admire'
  },
  {
    id: 1,
    text: 'agree'
  },
  {
    id: 2,
    text: 'allow'
  },
  {
    id: 3,
    text: 'answer'
  },
  {
    id: 4,
    text: 'ask'
  },
  {
    id: 5,
    text: 'be'
  },
  {
    id: 6,
    text: 'become'
  },
  {
    id: 7,
    text: 'begin'
  },
  {
    id: 8,
    text: 'believe'
  },
  {
    id: 9,
    text: 'borrow'
  },
  {
    id: 10,
    text: 'break'
  },
  {
    id: 11,
    text: 'bring'
  },
  {
    id: 12,
    text: 'build'
  },
  {
    id: 13,
    text: 'buy'
  },
  {
    id: 14,
    text: 'call'
  },
  {
    id: 15,
    text: 'carry'
  },
  {
    id: 16,
    text: 'charge'
  },
  {
    id: 17,
    text: 'choose'
  },
  {
    id: 18,
    text: 'close'
  },
  {
    id: 19,
    text: 'come'
  },
  {
    id: 20,
    text: 'cut'
  },
  {
    id: 21,
    text: 'decide'
  },
  {
    id: 22,
    text: 'do'
  },
  {
    id: 23,
    text: 'dream'
  },
  {
    id: 24,
    text: 'drink'
  },
  {
    id: 25,
    text: 'drive'
  },
  {
    id: 26,
    text: 'eat'
  },
  {
    id: 27,
    text: 'explain'
  },
  {
    id: 28,
    text: 'fall'
  },
  {
    id: 29,
    text: 'feel'
  },
  {
    id: 30,
    text: 'fill'
  },
  {
    id: 31,
    text: 'find'
  },
  {
    id: 32,
    text: 'finish'
  },
  {
    id: 33,
    text: 'follow'
  },
  {
    id: 34,
    text: 'fly'
  },
  {
    id: 35,
    text: 'forget'
  },
  {
    id: 36,
    text: 'get'
  },
  {
    id: 37,
    text: 'give'
  },
  {
    id: 38,
    text: 'go'
  },
  {
    id: 39,
    text: 'happen'
  },
  {
    id: 40,
    text: 'have'
  },
  {
    id: 41,
    text: 'hear'
  },
  {
    id: 42,
    text: 'help'
  },
  {
    id: 43,
    text: 'hold'
  },
  {
    id: 44,
    text: 'keep'
  },
  {
    id: 45,
    text: 'know'
  },
  {
    id: 46,
    text: 'learn'
  },
  {
    id: 47,
    text: 'leave'
  },
  {
    id: 48,
    text: 'like'
  },
  {
    id: 49,
    text: 'listen'
  },
  {
    id: 50,
    text: 'live'
  },
  {
    id: 51,
    text: 'look'
  },
  {
    id: 52,
    text: 'lose'
  },
  {
    id: 53,
    text: 'make'
  },
  {
    id: 54,
    text: 'mean'
  }
]

export default verbs



// WEBPACK FOOTER //
// ./src/assets/verbs.js